"use client"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Shield, Palette, Heart, TrendingUp } from "lucide-react"

import { motion } from "framer-motion"

export default function Commitment() {
    const commitments = [
        {
            title: "Integrity & Transparency",
            icon: Shield,
            description:
                'Compliance is non-negotiable. Our process aligns with GRI 2021, IFRS (IR), SASB, and CSRD to keep auditors and regulators confident. We never "beautify" numbers.',
            color: "bg-teal-700",
        },
        {
            title: "Tailor-Made Design Strategy",
            icon: Palette,
            description:
                "No two organizations tell the same story. We map your industry landscape, material topics, and stakeholder expectations to craft a bespoke visual language.",
            color: "bg-teal-700",
        },
        {
            title: "Honest and Ethical",
            icon: Heart,
            description:
                "We never share or release any data until your report is formally disclosed by the company. Our team stays responsive, transparent, and deadline-focused.",
            color: "bg-teal-700",
        },
        {
            title: "Proven Impact",
            icon: TrendingUp,
            description:
                "We build long-term relationships, not one-off projects. With 150+ integrated, sustainability, and annual reports delivered across 12 sectors, our work consistently delivers results.",
            color: "bg-teal-700",
        },
    ]

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    }

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" },
        },
    }

    return (
        <section className="py-10 my-10 px-4 bg-gray-50">
            <div className="max-w-6xl mx-auto">

                <motion.div
                    initial="visible"
                    variants={containerVariants}
                    className="text-center mb-10 md:mb-16"
                >

                    <motion.h2
                        variants={itemVariants}
                        className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4"
                    >
                        Our Commitments
                    </motion.h2>

                    <motion.p variants={itemVariants} className="text-base md:text-lg text-gray-600 max-w-4xl mx-auto">
                        Built on trust, transparency, and proven results - these are the principles that guide everything we do.
                    </motion.p>
                </motion.div>




                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {commitments.map((commitment, index) => {
                        const IconComponent = commitment.icon
                        return (
                            <Card key={index} className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                                <CardHeader className={`${commitment.color} text-white p-6`}>
                                    <div className="flex items-center gap-3">
                                        <IconComponent className="h-6 w-6" />
                                        <CardTitle className="text-xl font-semibold">{commitment.title}</CardTitle>
                                    </div>
                                </CardHeader>
                                <CardContent className="p-6 bg-white">
                                    <p className="text-gray-700 leading-relaxed">{commitment.description}</p>
                                </CardContent>
                            </Card>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
